import React from 'react';
import { connect } from 'react-redux';
import { fallbackBoundary } from 'decorators/FallbackBoundary';
import { decorateWith, withName } from 'helpers/decorator';
import { hideModal, selectActiveModalName, selectActiveModalProps } from 'redux/modules/modals';
import { ModalHost } from './ModalHost';
import { ModalError } from './ModalError';

export const mapStateToProps = state => ({
  modalName: selectActiveModalName(state),
  modalProps: selectActiveModalProps(state),
});

export const mapDispatchToProps = {
  onHideRequest: hideModal,
};

// eslint-disable-next-line react/prop-types
export const renderFallback = ({ handleResetError, ...props }) => (
  <ModalError {...props} onModalClose={handleResetError} />
);

export const ModalHostContainer = decorateWith(
  fallbackBoundary({ renderFallback }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('ModalHostContainer')
)(ModalHost);
